import * as React from "react";

function SvgPlanetMars(props) {
  return (
    <svg viewBox="0 0 80.24 80.24" {...props}>
      <defs>
        <radialGradient
          id="planet-mars_svg__d"
          cx={-244.39}
          cy={-158.53}
          r={43.51}
          gradientTransform="matrix(.03 -.89 .91 -.16 168.24 -223.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.77} />
        </radialGradient>
        <radialGradient
          id="planet-mars_svg__f"
          cx={-244.39}
          cy={-158.53}
          r={43.51}
          gradientTransform="matrix(.03 -.89 .91 -.16 168.24 -223.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.77} stopColor="#f3f9f7" />
        </radialGradient>
        <filter
          id="planet-mars_svg__a"
          x={3.35}
          y={-8184.39}
          width={47.73}
          height={32766}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <filter
          id="planet-mars_svg__c"
          x={3.35}
          y={4.7}
          width={47.73}
          height={47.25}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <mask
          id="planet-mars_svg__e"
          x={3.35}
          y={4.7}
          width={47.73}
          height={47.25}
          maskUnits="userSpaceOnUse"
        >
          <g mask="url(#planet-mars_svg__b)" filter="url(#planet-mars_svg__c)">
            <path
              d="M12.67 13.18C22.79 3.46 39 1.57 47.44 10.27s.77 16.57-8.91 28.59c-8 9.87-21.61 18.13-30.09 9.42s-5.89-25.38 4.23-35.1z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="url(#planet-mars_svg__d)"
            />
          </g>
        </mask>
      </defs>
      <g data-name="Layer 2">
        <ellipse cx={40.12} cy={40.12} rx={40.11} ry={40.1} fill="#ea490c" />
        <path
          d="M9.87 13.84a33.12 33.12 0 11-2.13 2.67 40.19 40.19 0 102.13-2.67z"
          fill="#d52b0c"
        />
        <path
          d="M62.14 61a41.86 41.86 0 01-49.21 8.66 40.16 40.16 0 0054.55-58.91c-.18-.17-.25 0-.43-.16A41.79 41.79 0 0162.14 61z"
          fill="#a6000a"
        />
        <path
          d="M45 44a12.78 12.78 0 00-4.11.67c-1.19.4-2.5 1-3.62.42a2.57 2.57 0 01-.68-.49 8.67 8.67 0 00.56-1.38c.44-1.48 0-3.44-1.41-3.94s-2.85.7-4.19 1.44a7.7 7.7 0 01-11.44-6.87c0-1.54.3-3.53-1.09-4.2s-2.62.54-3.34 1.72-1.41 2.63-2.68 3a3.11 3.11 0 01-3.29-1.48 9 9 0 01-1.12-3.67 10.81 10.81 0 01-.07-4.35 11.56 11.56 0 012.12-3.75 8.61 8.61 0 001.88-3.86 3.25 3.25 0 00-1.88-3.54l.13-.87A39.93 39.93 0 00.3 35.33c-.14 1.64-.22 3.3-.22 5a39.89 39.89 0 0015.06 31.15l.4.32.76.58q.66.5 1.35 1l.12.08A40.26 40.26 0 0022.18 76a11.56 11.56 0 001-.58c1.06-.66 2.14-1.74 1.91-3-.14-.8-.8-1.41-1.09-2.17-.4-1.07 0-2.24.15-3.37s-.05-2.52-1.1-3c-1.74-.75-2.34 1.24-3.56 1.95-1.9 1.11-4.74-1-5.85-2.41a11.16 11.16 0 01-2-8.79c.58-3 2.1-3.88 5.18-4.09a10.57 10.57 0 015.8 1.82c1.87 1.08 3.53 2.2 5.64 2.44l.11.28a7 7 0 002.42 0c1.56.21 3.13.29 4.36-.94s1.27-2.83 2.25-4c2-2.42 6.07-1.66 8.42-3.71.58-.51 1-1.41.54-2A1.76 1.76 0 0045 44z"
          fill="#b4000c"
        />
        <path
          d="M69.1 31.63c.93-.63 2.44-.61 3 .38.43.83.14 2.15 1 2.5a1.12 1.12 0 001.29-.5 3.16 3.16 0 00.44-1.42c.23-1.51.45-3 .68-4.54.72 0 1.08.86 1.27 1.56s.6 1.54 1.33 1.49a.84.84 0 00.43-.16A40 40 0 0068 12.19 29.17 29.17 0 0169.69 17a13.6 13.6 0 01-.19 8.09c-1.08 2.89-3.47 5.27-4.67 8a1.19 1.19 0 002 1.21 1.47 1.47 0 01.1-.13 10.49 10.49 0 012.17-2.54z"
          fill="#cc000c"
        />
        <path
          d="M39.53.38a41 41 0 00-6.31.49 8.78 8.78 0 014.48 1.25c1.92 1.26 3 4 1.84 6a17.29 17.29 0 01-1.81 2 2.53 2.53 0 00-.67 2.5c.57 1.38 2.63 1.38 3.54 2.51s.36 2.69-.17 4-1 2.9-.09 4a2.65 2.65 0 003.23.34A7.75 7.75 0 0046 20.89a7.47 7.47 0 001.26 3.77c.85 1 2.57 1.48 3.54.55.79-.76.91-2.21 1.95-2.56a4 4 0 011.38 0c1.76 0 3.19-1.37 4.24-2.78A23.25 23.25 0 0062.53 10a17.19 17.19 0 00.23-2.16A40 40 0 0039.53.38z"
          fill="#d40d00"
        />
        <path
          d="M8.88 57.35a2 2 0 01-1.42-.05c-2.77-.94-4-4.17-4.32-7.08s-.06-6-1.31-8.62a15.28 15.28 0 01-1-2.25 7.88 7.88 0 01.07-3.64l1.32-6.9c.14-.72.39-1.58 1.1-1.78 1-.28 1.7 1 1.84 2 .28 2.18-.23 4.47.49 6.55a6 6 0 007.81 3.3c-.35.38 0 1.06.45 1.23a2.14 2.14 0 001.52-.19 3.07 3.07 0 011.5-.36 2.23 2.23 0 011.59 1.53 13 13 0 00.82 2.16c.87 1.41 2.69 1.81 4.25 2.36s3.25 1.83 3 3.47A2.6 2.6 0 0124.83 51a4.82 4.82 0 01-2.69 0c-2.05-.47-3.87-1.67-5.88-2.31s-4.53-.54-5.83 1.11a5.41 5.41 0 00-.76 4.2 7.34 7.34 0 01.18 1.86 1.82 1.82 0 01-.97 1.49z"
          fill="#cc000c"
        />
        <path
          d="M63.37 18.71c.76 2.43-1.95 4.82-1.5 7.32a2.06 2.06 0 00.91 1.44 2.58 2.58 0 002.84-.65 7.39 7.39 0 002.45-5.13 9.13 9.13 0 00-1.56-5.52 3.94 3.94 0 00-2-1.73 1.82 1.82 0 00-2.24.89 2.24 2.24 0 00.24 1.76 10.32 10.32 0 01.86 1.62z"
          fill="#cb1c00"
        />
        <path
          d="M68.75 37.09a2 2 0 00-2.39-1.31c-1 .37-1.26 1.56-1.56 2.55a11.42 11.42 0 01-2.4 4.23 3.42 3.42 0 01-1.3 1 1.41 1.41 0 01-1.52-.31c-.6-.72 0-1.79.47-2.58a30.61 30.61 0 003.42-6.9 4.52 4.52 0 00.34-1.91 1.71 1.71 0 00-1.08-1.5c-.92-.29-1.85.57-2.14 1.5a24.63 24.63 0 00-.36 2.88l-.52-.25A24.92 24.92 0 0141 49.87a3.82 3.82 0 00-2.15.83c-.66.69-.63 1.76-.76 2.7A6.75 6.75 0 0127.53 58c-1-.7-2.08-1.74-3.23-1.33a1.94 1.94 0 00-1 2.39 3.93 3.93 0 001.87 2.07 8.6 8.6 0 005.41 1.11c1.29-.17 2.73-.59 3.77.18.67.5 1 1.37 1.51 2 1 1.1 2.65 1.25 4.13 1.17a7.12 7.12 0 003.68-1 3.16 3.16 0 001.41-3.33c-.21-.71-.74-1.3-.89-2a2.72 2.72 0 01.92-2.4 8 8 0 012.31-1.36 2.44 2.44 0 011.85-.28c1 .39 1 1.75.77 2.78s-.49 2.27.28 3 2.09.3 3.05-.22a31 31 0 0015.39-20.72 5.09 5.09 0 00-.01-2.97z"
          fill="#e24100"
        />
        <path
          d="M34.55 60.08a5.11 5.11 0 01-5.1 0c-1.18-.69-2.14-1.89-3.49-2a1.59 1.59 0 00-1.07.2.93.93 0 00-.44.94c.1.53.7.79 1.22.94a21.21 21.21 0 005.63 1 31.3 31.3 0 005.54-.52.7.7 0 000-1.08 1.24 1.24 0 00-1.21-.11 7.06 7.06 0 00-1.08.63zM57.74 25.34A14.81 14.81 0 0053 32.11a1.77 1.77 0 00.09 1.75 1.59 1.59 0 001.53.26 6.45 6.45 0 003.8-2.94A12.93 12.93 0 0060 26.56c.1-.57.15-1.26-.3-1.63s-1.38-.06-1.96.41z"
          fill="#ff5900"
        />
        <path
          d="M45.28.36a9.61 9.61 0 01-.3 10.9 8.42 8.42 0 00-1.62 2.33 1.81 1.81 0 001 2.36c1.61.41 2.59-2.35 4.25-2.19 1.13.11 1.63 1.54 1.48 2.66s-.67 2.23-.52 3.35 1.53 2.16 2.4 1.43c.67-.56.46-1.62.69-2.47.48-1.83 2.78-2.32 4.34-3.4 2.1-1.46 2.88-4.15 3.52-6.62A16.74 16.74 0 0061 5.89 39.9 39.9 0 0045.28.36z"
          fill="#cc000c"
        />
        <path
          d="M24.27 36.76c-.66 1 .22 2.4 1.36 2.7a5.06 5.06 0 003.37-.69 7.39 7.39 0 013.32-1.1 2.9 2.9 0 001.76-.16 1.32 1.32 0 00.4-1.46 2.89 2.89 0 00-1-1.29A8.2 8.2 0 0026.7 33a4.69 4.69 0 00-3.24 2c-.66 1.09-.33 1.11.81 1.76zM70.54 32.89c-.89.38-.76 1.64-.57 2.58a15.1 15.1 0 01-1.7 10.45 22.56 22.56 0 00-1.44 2.58 3.74 3.74 0 00-.12 2.88l.52-.07a52.4 52.4 0 004-7.76A17.79 17.79 0 0072.54 35a3.23 3.23 0 00-.54-1.6 1.32 1.32 0 00-1.46-.51z"
          fill="#ff5900"
        />
        <path
          d="M48.93 61.32a5.07 5.07 0 01-.41 3.08 2.64 2.64 0 01-2.59 1.45.75.75 0 01-.48-.23c-.26-.33 0-.8.27-1.15a4.57 4.57 0 00-.21-5.28 1.62 1.62 0 012.33-.19 3.58 3.58 0 011.09 2.32zM39.32 39.11a4.38 4.38 0 00-1.54 2.34 1.51 1.51 0 00.33 1.61 1.78 1.78 0 001.33.17 12.25 12.25 0 005.72-1.74c1.63-1.18 2.59-3.55 1.54-5.27s-3.65-2-5.41-1-.36 2.65-1.97 3.89z"
          fill="#d52b0c"
        />
        <path
          d="M0 40.12a39.87 39.87 0 003.63 16.64c14.32 3.76 29-1 39.85-12.49 11.18-11.86 15.22-27.77 9.89-42A40.11 40.11 0 000 40.12z"
          fill="#fff"
          opacity={0.15}
        />
        <g mask="url(#planet-mars_svg__e)">
          <path
            d="M12.67 13.18C22.79 3.46 39 1.57 47.44 10.27s.77 16.57-8.91 28.59c-8 9.87-21.61 18.13-30.09 9.42s-5.89-25.38 4.23-35.1z"
            opacity={0.49}
            fill="url(#planet-mars_svg__f)"
          />
        </g>
        <path
          d="M80.23 40.12A40.13 40.13 0 0031.79.89a40 40 0 0125.84 4 39.48 39.48 0 0116.44 53.6 40 40 0 01-54 16.27l-.78-.43a39.93 39.93 0 0017.59 5.71l.72.06h2.56a40.1 40.1 0 0040.07-39.98z"
          style={{
            mixBlendMode: "screen",
          }}
          fill="#fff"
          opacity={0.24}
        />
        <path
          d="M27.08 69.92c1.33.06 2.39 1.07 3.45 1.87a14.09 14.09 0 007.33 2.81v.88A22.67 22.67 0 0125 74.59c-1.7-.59-3.54-1.88-3.35-3.59 1.71.73 3.54-1.15 5.43-1.08z"
          fill="#b4000c"
        />
      </g>
    </svg>
  );
}

export default SvgPlanetMars;
